import { ISSUE_PARENT_PANEL_SHORTCUT, VERSION_PANEL_SHORTCUT } from './constants.tsx';
import type { PanelType, PanelShortcuts } from './types.tsx';

const panelShortcuts: PanelShortcuts = {
	Epic: ISSUE_PARENT_PANEL_SHORTCUT,
	Version: VERSION_PANEL_SHORTCUT,
};
export const getKeyboardShortcutForPanel = (panelType: PanelType) => panelShortcuts[panelType];
